export { default } from './Rating';
export type { RatingProps } from './Rating';
